import { render, staticRenderFns } from "./CItemProductionFacility.vue?vue&type=template&id=51665c93"
import script from "./CItemProductionFacility.vue?vue&type=script&lang=js"
export * from "./CItemProductionFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports